var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.instance || !_setup.latestTemplate)?_c(_setup.LoadingSpan,{attrs:{"message":"Loading storage location instance and templates"}}):_c(_setup.UpgradeForm,{attrs:{"instance":_setup.instance,"latest-template":_setup.latestTemplate}})
}
var staticRenderFns = []

export { render, staticRenderFns }